define('components/course/models/slide-type/full-width',[
    "components/course/models/slide-type/tei-wrapper"
], function(BaseModel) {
    "use strict";

    return BaseModel.extend({
        "populateDefaultData": function() {
            if (!this.get('data')) {
                this.set('data', {
                    "reportingType": BaseModel.REPORTING_TYPES.STANDARD,
                    "teaGUID": null,
                    "title": null,
                    "studentResponseScore": 0,
                    "showFeedback": true,
                    "bAddCustomFeedback": false,
                    "sCustomFeedback": "",
                    "userScoreStatus": null,
                    "maxScoreStatus": null,
                    "lastLoadedIndex": null
                });
            } else if (!this.get('data').reportingType) {
                this.get('data').reportingType = BaseModel.REPORTING_TYPES.STANDARD;
            }
            BaseModel.prototype.populateDefaultData.call(this);
            return this;
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "teaGUID": null,
                    "title": null,
                    "studentResponseScore": null,
                    "reportingType": null,
                    "showFeedback": null,
                    "bAddCustomFeedback": null,
                    "sCustomFeedback": null,
                    "userScoreStatus": null,
                    "maxScoreStatus": null,
                    "globalComponentData": null
                }
            });
        }
    });
});

